import { createSvgComponent } from "../../icon/createSvgComponent";
import GovFill from "@core/icon/assets/gov-fill.svg";
export default createSvgComponent(GovFill);